import { css } from 'linaria';

export const newKitchenUtpSectionModalContent = css`
  padding-bottom: 40px;

  @media (--only-mobile) {
    padding-bottom: 32px;
  }
`;

export const newKitchenUtpSectionModalText = css`
  margin-bottom: 8px;
`;

export const newKitchenUtpSectionModalList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;
